export const OPEN_DROPDOWN = 'OPEN_DROPDOWN';
export const CLOSE_DROPDOWN = 'CLOSE_DROPDOWN';
export const INIT_DROPDOWN = 'INIT_DROPDOWN';
export const NOTIFICATIONS_LOADED = 'NOTIFICATIONS_LOADED';
export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';
export const MARK_AS_READ = 'MARK_AS_READ';


// WEBPACK FOOTER //
// ./src/core/services/notifications/dropdown/action-types.js